<template lang="pug">
#box
  .boxShow(v-if="show" @click="changeBox(false)")
    i.el-icon-arrow-left
  .boxHidden(v-else @click="changeBox(true)")
    i.el-icon-arrow-right
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changeBox(open) {
      this.$emit('update:show', open);
    }
  }
};
</script>

<style lang="scss" scoped>
// 按钮
#box{
  width: 12px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.boxShow,.boxHidden {
  line-height: 48px;
  width: 12px;
  height: 45px;
  background: #8c95a8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
i{
  color: #fff;
  font-size: 15px;
}
.boxShow:hover,.boxHidden:hover{
  background: #4777e7;
}
</style>
